import { WeatherConditionProps } from "@whoosh/design-system/src/components/display/WeatherCondition";

import { TimeSlotListInternalQuery$data } from "../components/__generated__/TimeSlotListInternalQuery.graphql";

export const getArrayOfWeatherConditions = (
  data: TimeSlotListInternalQuery$data
) => {
  const agenda = data.node?.agendas?.edges
    ? data.node.agendas.edges[0]?.node
    : null;
  if (!agenda) {
    return [];
  }
  const weatherConditions = agenda.weatherConditions?.edges
    ? agenda.weatherConditions?.edges?.reduce(
        (acc: WeatherConditionProps[], cur) => {
          if (!cur?.node) {
            return acc;
          }
          const newCondition: WeatherConditionProps = { ...cur.node };
          if (acc.length === 0) {
            acc.push(newCondition);
          }
          const lastWeatherCondition = acc[acc.length - 1];
          if (
            newCondition.weatherCategory !==
              lastWeatherCondition.weatherCategory ||
            Math.abs(
              (newCondition.temperature || 0) -
                (lastWeatherCondition.temperature || 0)
            ) >= 5 ||
            Math.abs(
              newCondition.probabilityOfPrecipitationInPercent -
                lastWeatherCondition.probabilityOfPrecipitationInPercent
            ) >= 5 ||
            (Math.abs(
              (newCondition?.windSpeedInMph || 0) -
                (lastWeatherCondition?.windSpeedInMph || 0)
            ) > 5 &&
              ((newCondition?.windSpeedInMph || 0) > 10 ||
                lastWeatherCondition?.windSpeedInMph ||
                0 > 10))
          ) {
            acc.push(newCondition);
          }
          return acc;
        },
        []
      )
    : [];
  return weatherConditions;
};
